import { t } from "@redotech/redo-i18n";
import { localizeCustomerPortalFlowText } from "../../util";

/** Turns the stored drop-off fragments into the sentence shoppers see. */
export function dropOffStepCopy({
  title,
  subtitle,
  carrierDisplayName,
}: {
  title: string;
  subtitle: string;
  carrierDisplayName: string | undefined;
}): { title: string; subtitle: string } {
  const dropOffTitle = localizeCustomerPortalFlowText(title);
  const dropOffSubtitle = localizeCustomerPortalFlowText(subtitle);

  return {
    title:
      carrierDisplayName && dropOffTitle === t("Drop off package")
        ? t("Drop off package at {{carrier}}", {
            carrier: carrierDisplayName,
            context:
              "carrier is a proper noun such as FedEx, UPS, or USPS: do not translate it",
          })
        : carrierDisplayName
          ? `${dropOffTitle} ${t("at")} ${carrierDisplayName}`
          : dropOffTitle,
    subtitle:
      carrierDisplayName &&
      dropOffSubtitle === t("Take your package to a nearby")
        ? t("Take your package to a nearby {{carrier}} location", {
            carrier: carrierDisplayName,
            context:
              "carrier is a proper noun such as FedEx, UPS, or USPS: do not translate it and do not end the sentence with a colon",
          })
        : carrierDisplayName
          ? `${dropOffSubtitle} ${carrierDisplayName} ${t("location")}`
          : // The default subtitle is a fragment. Hide it until a carrier makes it a sentence.
            dropOffSubtitle === t("Take your package to a nearby")
            ? ""
            : dropOffSubtitle,
  };
}
